import {
    initialState,
    Actions,
    State,
    EDIT_SUBSCRIPTION,
    EDIT_SUBSCRIPTION_SUCCESS,
    EDIT_SUBSCRIPTION_ERROR,
    RESET_EDIT_SUBSCRIPTION,
  } from "../../types/subscription-admin/edit-subscription";
  
  const reducers = (state = initialState, action: Actions): State => {
    switch (action.type) {
      case EDIT_SUBSCRIPTION:
        return {
          ...state,
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        };
      case EDIT_SUBSCRIPTION_SUCCESS:
        return {
          ...state,
          data: action.payload,
          states: {
            loading: false,
            error: false,
            success: true,
          },
        };
      case EDIT_SUBSCRIPTION_ERROR:
        return {
          ...state,
          data: null,
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        };
      case RESET_EDIT_SUBSCRIPTION:
        return initialState;
      default:
        return state;
    }
  };
  
  export default reducers;
  